import {configureStore} from "@reduxjs/toolkit";
import {inMemoryPlusStatusReducer, inMemoryPlusStatusSliceName} from "../reusables/plus/APXPlus.js";
import payerReducer, {payerSliceName} from "./AddNewTripPayerReducer.js";
import inMemoryTripReducer, {inMemoryTripSliceName} from "./InMemoryTripReducer.js";


const store = configureStore({
	  reducer: {
			 [payerSliceName]: payerReducer,
			 // [tripKeysSliceName]: tripKeysReducer,
			 [inMemoryTripSliceName]: inMemoryTripReducer,
			 [inMemoryPlusStatusSliceName]: inMemoryPlusStatusReducer
	  }
});

export default store;